import moment from 'moment-timezone'

export default (date) => ({
  from: moment(date).startOf('week').toDate(),
  to: moment(date).endOf('week').toDate(),
})
